import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogConfirmacionComponent } from './dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from './dialog-procesando/dialog-procesando.component';
import { AngularMaterialModule } from '../../angular-material-module/angular-material.module';
import { DynamicFormInputComponent } from './dynamic-form-input/dynamic-form-input.component';
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { DecimalDigitosDirective } from '../common/directives/decimal-digitos.directive';
import { ConfirmImportComponent } from './confirm-import/confirm-import.component';
import { DateServerPipe } from '../../utils/date-server.pipe';

@NgModule({
  declarations: [DialogConfirmacionComponent, 
    DialogProcesandoComponent, 
    DynamicFormInputComponent, 
    DynamicFormComponent, 
    DecimalDigitosDirective, 
    ConfirmImportComponent,
    DateServerPipe],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    CheckboxModule,
    DropdownModule,
    TableModule
  ],
  exports: [DynamicFormComponent, DecimalDigitosDirective, DateServerPipe]
})
export class SharedModule { }
